import { render, staticRenderFns } from "./cartaomanual.vue?vue&type=template&id=0ecb680c&scoped=true&"
import script from "./cartaomanual.vue?vue&type=script&lang=js&"
export * from "./cartaomanual.vue?vue&type=script&lang=js&"
import style0 from "./cartaomanual.vue?vue&type=style&index=0&id=0ecb680c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb680c",
  null
  
)

export default component.exports